import React, { useState, useEffect } from "react";
import apiClient from "../utils/apiClient";
import Select from "react-select";
import Swal from "sweetalert2";
import { SERVER_BASE } from "../config/server";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlusCircle,
  faMinusCircle,
  faTrash,
  faEdit,
  faCopy,
  faEllipsisV,
  faThumbsUp,
  faCancel,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import {
  useTable,
  usePagination,
  useSortBy,
  useGlobalFilter,
} from "react-table";
import {hasPermission} from "../utils/usePermissions";
import { useNavigate } from "react-router-dom";
// Global Search Filter Component
const GlobalFilter = ({ filter, setFilter }) => {
  const handleChange = (e) => {
    setFilter(e.target.value);

    // Reset pagination to first page
    localStorage.setItem("currentAllPageIndex", 0);
    localStorage.setItem("currentRejectedPageIndex", 0);
    localStorage.setItem("currentFinalPageIndex", 0);
    localStorage.setItem("currentDraftPageIndex", 0);
  };

  return (
    <input
      value={filter || ""}
      onChange={handleChange}
      placeholder="Search items..."
      style={{
        marginBottom: "10px",
        padding: "8px",
        fontSize: "16px",
        width: "100%",
        boxSizing: "border-box",
      }}
      className="form-control"
    />
  );
};

const ItemMasterApproval = () => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("lastActiveTab") || "all";
  });
  const [isEdit, setIsEdit] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [itemGroup, setItemGroup] = useState(null);
  const [type, setType] = useState(null);
  const [itemGroupCode, setItemGroupCode] = useState("");
  const [itemCode, setItemCode] = useState("");
  const [itemName, setItemName] = useState("");
  const [printName, setPrintName] = useState("");
  const [itemDesc, setItemDesc] = useState("");
  const [size, setSize] = useState("");
  const [make, setMake] = useState("");
  const [color, setColor] = useState("");
  const [avgWeight, setAvgWeight] = useState("");
  const [uom, setUom] = useState(null);
  const [unit, setUnit] = useState("");
  const [concernedDepartments, setConcernedDepartments] = useState([]);
  const [remarks, setRemarks] = useState("");
  const [additionalNames, setAdditionalNames] = useState([""]);
  const [grade, setGrade] = useState("");
  const [mmsCode, setMmsCode] = useState("");
  const [mmsName, setMmsName] = useState("");
  const [mmsDesc, setMmsDesc] = useState("");
  const [groupItemName, setGroupItemName] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [items, setItems] = useState([]); // State for table data
  const [approvedItems, setApprovedItems] = useState([]); // State for table data
  const [rejectedItems, setRejectedItems] = useState([]);
  const [suggestion, setSuggestions] = useState([]);
  const code = localStorage.getItem("code");
  const email = localStorage.getItem("email");
  const token = localStorage.getItem("token");
  const [formVisible, setFormVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [uoms, setUoms] = useState([]); // UOM data
  const [groupItems, setGroupItems] = useState([]);
  const [createdByOptions, setCreatedByOptions] = useState([]);
  const [typeFilter, setTypeFilter] = useState(() => {
    return localStorage.getItem("typeFilter") || "All";
  });
  const [groupFilterCode, setGroupFilterCode] = useState(() => {
    return localStorage.getItem("groupFilterCode") || "";
  });
  const [createdByFilter, setCreatedByFilter] = useState(() => {
    const saved = localStorage.getItem("createdByFilter");
    return saved ? JSON.parse(saved) : null;
  });
  const navigate = useNavigate();

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    localStorage.setItem("lastActiveTab", tab);
  };

  // Fetch Inventory Groups
  const fetchItemGroups = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/item-groups", {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setItemGroups(
        response.data.map((group) => ({
          value: group.groupName,
          label: `${group.groupCode} - ${group.groupName}`,
          type: group.type,
          itemGroupCode: group.groupCode,
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };
  const fetchGroupItems = async () => {
    try {
      // Retrieve the token from localStorage
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Unauthorized: No token found.");
        return;
      }
      // Make the request with the Authorization header
      const response = await apiClient.get(SERVER_BASE + "/getGroupItems", {
        headers: {
          Authorization: `Bearer ${token}`, // Include the JWT token in headers
        },
      });

      // Update the purposes state
      setGroupItems(response.data);
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };
  const fetchUOMs = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/getUoms", {
        params: { code },
        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      setUoms(
        response.data.map((uom) => ({
          value: uom.abbreviation,
          label: `${uom.unit} - ${uom.abbreviation}`,
          unit: uom.unit,
        }))
      );
    } catch (error) {
      console.error("Error fetching item groups:", error);
    }
  };

  // Fetch Departments
  const fetchDepartments = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/departments", {
        params: { code },

        headers: {
          Authorization: `Bearer ${token}`, // Add the JWT token in the header
        },
      });
      const departmentsData = response.data;
      setDepartments(
        departmentsData.map((dept) => ({
          value: dept.name,
          label: dept.name,
        }))
      );
    } catch (error) {
      console.error("Error fetching departments:", error);
    }
  };
  const generateCreatedByOptions = (allItems) => {
    const uniqueCreatedByMap = new Map();

    allItems.forEach((item) => {
      const compositeKey = `${item.badgeId}|${item.createdByFirstName}`;
      if (!uniqueCreatedByMap.has(compositeKey)) {
        uniqueCreatedByMap.set(compositeKey, {
          value: item.badgeId,
          label: `${item.createdByFirstName} - ${item.badgeId}`,
          name: item.createdByFirstName,
        });
      }
    });

    return Array.from(uniqueCreatedByMap.values());
  };
  const fetchAllItems = async () => {
    try {
      const [allRes, approvedRes, rejectedRes] = await Promise.all([
        apiClient.get(SERVER_BASE + "/get-items", {
          params: { centerCode: code },
          headers: { Authorization: `Bearer ${token}` },
        }),
        apiClient.get(SERVER_BASE + "/get-items-approved", {
          params: { centerCode: code },
          headers: { Authorization: `Bearer ${token}` },
        }),
        apiClient.get(SERVER_BASE + "/get-items-rejected", {
          params: { centerCode: code },
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);

      const sortedItems = allRes.data.sort((a, b) => b.id - a.id);
      const sortedApproved = approvedRes.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt)
      );
      const sortedRejected = rejectedRes.data.sort(
        (a, b) => new Date(b.approvedAt) - new Date(a.approvedAt)
      );

      setItems(sortedItems);
      setApprovedItems(sortedApproved);
      setRejectedItems(sortedRejected);

      const combinedItems = [
        ...sortedItems,
        ...sortedApproved,
        ...sortedRejected,
      ];
      const createdByOptions = generateCreatedByOptions(combinedItems);
      setCreatedByOptions(createdByOptions);
    } catch (error) {
      setItems([]);
      setApprovedItems([]);
      setRejectedItems([]);
      console.error("Error fetching items:", error);
    }
  };

  // Fetch items for the table
  const fetchItems = async () => {
    try {
      const response = await apiClient.get(SERVER_BASE + "/get-items", {
        params: { centerCode: code },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const fetchSuggestions = async () => {
    try {
      const response = await apiClient.get(
        SERVER_BASE + "/getInventorySuggestions"
      );
      setSuggestions(response?.data?.suggestions);
    } catch (error) {
      console.error("Error fetching suggestion:", error);
    }
  };

  // Function to update the Print Name dynamically
  useEffect(() => {
    const baseName = `${itemName} ${size} ${color}`.trim();
    const additionalDetails = [make, grade].filter(Boolean).join(" ");
    const newPrintName = additionalDetails
      ? `${baseName} - ${additionalDetails}`
      : baseName;
    setPrintName(newPrintName);
  }, [itemName, color, size, make, grade]); // Dependencies

  const handleEdit = async (item) => {
    try {
      // Call backend to check if item is used
      const response = await apiClient.post("/checkItemUsed", { itemId: item.id });
  
      if (response.data.used) {
        Swal.fire({
          icon: "warning",
          title: "This item is already in use and can not be edited",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        navigate("../ItemMasterForm", { state: { item } });
      }
    } catch (error) {
      console.error("Error checking item usage:", error);
      Swal.fire({
        icon: "error",
        title: "Something went wrong!",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };
  const handleApproveSuggestion = (suggestionRow) => {
    navigate("../ItemMasterForm", {
      state: {
        item: suggestionRow?.itemDetails,
        suggestionData: suggestionRow,
        fromSuggestion: true,
      },
    });
  };
  const handleDeleteSuggestion = async (id) => {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this suggestion? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });
  
    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.delete(SERVER_BASE+'/deleteSuggestion', {
          data: {id:id},
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        Swal.fire({
          icon: 'success',
          title: 'Suggestion deleted successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        navigate('../itemApproval')
      } catch (error) {
        console.error('Error deleting suggestion:', error);

      }
    }
  };
  const handleRejectSuggestion = async (id) => {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to reject this suggestion? This action cannot be undone!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, reject it!',
      cancelButtonText: 'Cancel',
    });
  
    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.put(SERVER_BASE+'/rejectSuggestion', {
          data: {id:id},
          headers: {
            Authorization: `Bearer ${token}`, // Add the JWT token in the header
          },
        });

        Swal.fire({
          icon: 'success',
          title: 'Suggestion rejected successfully!',
          toast: true,
          position: 'top-end',
          timer: 3000,
          showConfirmButton: false,
        });
        navigate('../itemApproval')
      } catch (error) {
        console.error('Error rejecting suggestion:', error);

      }
    }
  };
  const handleDelete = async (row) => {
    const { id, code } = row; // Destructure necessary fields
  
    try {
      // First, check if the item is used
      const checkResponse = await apiClient.post(SERVER_BASE + "/checkItemUsed", { itemId: id });
      if (checkResponse.data.used) {
        Swal.fire({
          icon: "warning",
          title: "This item is already in use and cannot be deleted!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
        return; // Stop deletion
      }
  
      // Ask for confirmation only if item is not used
      const confirmation = await Swal.fire({
        title: "Are you sure?",
        text: "Do you want to delete this Inventory? This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
  
      if (confirmation.isConfirmed) {
        // Proceed to delete
        await apiClient.delete(SERVER_BASE + "/deleteItemMaster", {
          data: { id, code },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        fetchAllItems();
        Swal.fire({
          icon: "success",
          title: "Inventory deleted successfully!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error deleting Inventory:", error);
      Swal.fire({
        icon: "error",
        title: "An error occurred while deleting the Inventory.",
        toast: true,
        position: "top-end",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };
  
  const handleApprove = async (row) => {
    const { id } = row; // Destructure the necessary fields from row.original
    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to approve this Inventory? This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "Cancel",
    });

    if (confirmation.isConfirmed) {
      try {
        // Send the entire row data to the server
        await apiClient.put(
          `${SERVER_BASE}/approveItemMaster`,
          { id, code, email },
          {
            headers: {
              Authorization: `Bearer ${token}`, // Correct header position
            },
          }
        );
        fetchAllItems();
        Swal.fire({
          icon: "success",
          title: "Inventory approved successfully!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error approved Inventory:", error);

        Swal.fire({
          icon: "error",
          title: "An error occurred while approved the Inventory.",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };
  const handleReject = async (item) => {
    let selectedValues = []; // track selected reasons

    const { value: formValues } = await Swal.fire({
      title: "Reject Item",
      html: `
        <div class="container text-start p-2">
          <div class="mb-3">
            <label for="rejectReason" class="form-label fw-bold">Hold Reasons</label>
            <select id="rejectReason" class="form-select">
              <option value="">-- Select Reason --</option>
              <option value="Confirm Inventory Name">Confirm Inventory Name</option>
              <option value="Confirm Dimensions">Confirm Dimensions</option>
              <option value="Confirm Color">Confirm Color</option>
              <option value="Confirm Inventory Material">Confirm Inventory Material</option>
              <option value="Confirm Brand Name">Confirm Brand Name</option>
              <option value="Other">Other</option>
            </select>
            <div id="selectedReasons" class="mt-2 d-flex flex-wrap gap-2"></div>
          </div>
          <div class="mb-3">
            <label for="remarkText" class="form-label fw-bold">Remarks</label>
            <textarea id="remarkText" class="form-control" rows="4" placeholder="Enter your remarks here..."></textarea>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Hold",
      cancelButtonText: "Cancel",
      focusConfirm: false,
      didOpen: () => {
        const select = document.getElementById("rejectReason");
        const container = document.getElementById("selectedReasons");

        select.addEventListener("change", () => {
          const value = select.value;
          if (value && !selectedValues.includes(value)) {
            selectedValues.push(value);

            // Remove from dropdown
            const option = select.querySelector(`option[value="${value}"]`);
            if (option) option.remove();

            // Create badge
            const badge = document.createElement("span");
            badge.className =
              "badge bg-primary d-flex align-items-center gap-1 p-2";
            badge.innerHTML = `${value} <span style="cursor:pointer;">&times;</span>`;

            // Handle remove
            badge.querySelector("span").addEventListener("click", () => {
              selectedValues = selectedValues.filter((v) => v !== value);

              // Add back to dropdown
              const newOption = document.createElement("option");
              newOption.value = value;
              newOption.textContent = value;
              select.appendChild(newOption);

              badge.remove();
            });

            container.appendChild(badge);
          }
          select.value = ""; // reset dropdown
        });
      },
      preConfirm: () => {
        const remark = document.getElementById("remarkText").value.trim();

        if (selectedValues.length === 0) {
          Swal.showValidationMessage(`Please select at least one Reject Reason`);
          return false;
        }

        if (selectedValues.includes("Other") && !remark) {
          Swal.showValidationMessage(
            `Remarks are required when 'Other' is selected`
          );
          return false;
        }

        return { reasons: selectedValues.join(","), remark };
      },
    });

    if (formValues) {
      const { reasons, remark } = formValues;

      try {
        await apiClient.put(`${SERVER_BASE}/reject-item`, {
          id: item.id,
          reasons, // comma-separated string
          remark,
          email,
        });

        fetchAllItems();

        Swal.fire({
          icon: "success",
          title: "Inventory moved on hold successfully!",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error rejecting Inventory:", error);
        Swal.fire({
          icon: "error",
          title: "An error occurred while rejecting the Inventory.",
          toast: true,
          position: "top-end",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    }
  };

  const resetAllFilters = () => {
    localStorage.setItem("currentDraftPageIndex", 0);
    localStorage.setItem("currentDraftPageSize", 25);
    localStorage.setItem("currentFinalPageIndex", 0);
    localStorage.setItem("currentFinalPageSize", 25);
    localStorage.setItem("currentRejectedPageIndex", 0);
    localStorage.setItem("currentRejectedPageSize", 25);
  };

  useEffect(() => {
    fetchItemGroups();
    fetchDepartments();
    fetchAllItems();
    fetchUOMs();
    fetchGroupItems();
    fetchSuggestions();
  }, []);

  // React Table configuration
  const columns = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      { Header: "Inventory", accessor: "itemName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made of (Material)", accessor: "make" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      {
        Header: "Group",
        accessor: "itemGroupCode", // still needed for sorting/filtering
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        },
      },
      { Header: "Type", accessor: "type" },
      // {
      //   Header: "Created By",
      //   accessor: "createdByFirstName",
      //   Cell: ({ row }) => {
      //     const { createdByFirstName, createdAt } = row.original;
      //     const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //     });
      //     return `${createdByFirstName} On (${formattedDate})`;
      //   },
      // },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-2 align-items-center">
              {/* Direct Edit Button */}
              <button
                className="btn btn-sm btn-outline-info"
                onClick={() => handleEdit(row.original)}
              >
                <FontAwesomeIcon icon={faEdit} />
              </button>

              {/* Kebab Dropdown for Other Actions */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleApprove(row.original)}
                    >
                      <FontAwesomeIcon icon={faThumbsUp} className="me-2" />
                      Approve
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleDelete(row.original)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleReject(row.original)}
                    >
                      <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                      Reject
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item">
                      <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                      {row.original.createdByFirstName}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      },
    ],
    []
  );
  const columnsApproved = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      { Header: "Inventory", accessor: "itemName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made of (Material)", accessor: "make" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      {
        Header: "Group",
        accessor: "itemGroupCode", // still needed for sorting/filtering
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        },
      },
      { Header: "Type", accessor: "type" },
      // {
      //   Header: "Created By",
      //   accessor: "createdByFirstName",
      //   Cell: ({ row }) => {
      //     const { createdByFirstName, createdAt } = row.original; // Access original row data
      //     const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //     }); // Format date as DD-MM
      //     return `${createdByFirstName} On (${formattedDate})`;
      //   },
      // },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-2 align-items-center">
              {/* Kebab Dropdown for Other Actions */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleEdit(row.original)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleDelete(row.original)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </button>
                  </li>
                  {/* <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleReject(row.original)}
                    >
                      <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                      Reject
                    </button>
                  </li> */}
                  <li>
                    <button className="dropdown-item">
                      <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                      {row.original.createdByFirstName}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      },
    ],
    []
  );
  const columnsRejected = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      { Header: "Inventory", accessor: "itemName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made of (Material)", accessor: "make" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      {
        Header: "Group",
        accessor: "itemGroupCode", // still needed for sorting/filtering
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        },
      },
      { Header: "Type", accessor: "type" },
      { Header: "Reason", accessor: "rejectedReason" },
      // {
      //   Header: "Created By",
      //   accessor: "createdByFirstName",
      //   Cell: ({ row }) => {
      //     const { createdByFirstName, createdAt } = row.original; // Access original row data
      //     const formattedDate = new Date(createdAt).toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //     }); // Format date as DD-MM
      //     return `${createdByFirstName} On (${formattedDate})`;
      //   },
      // },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="d-flex gap-2 align-items-center">
              {/* Kebab Dropdown for Other Actions */}
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-outline-secondary "
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FontAwesomeIcon icon={faEllipsisV} />
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleEdit(row.original)}
                    >
                      <FontAwesomeIcon icon={faEdit} className="me-2" />
                      Edit
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleApprove(row.original)}
                    >
                      <FontAwesomeIcon icon={faThumbsUp} className="me-2" />
                      Approve
                    </button>
                  </li>
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => handleDelete(row.original)}
                    >
                      <FontAwesomeIcon icon={faTrash} className="me-2" />
                      Delete
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item">
                      <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                      {row.original.createdByFirstName}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          );
        },
      },
    ],
    []
  );
  const columnSuggestion = React.useMemo(
    () => [
      { Header: "Associated Inventory", accessor: "printName" },
      { Header: "Inventory", accessor: "inventoryName" },
      { Header: "Size", accessor: "size" },
      { Header: "Color", accessor: "color" },
      { Header: "Made Of", accessor: "madeOf" },
      { Header: "Grade", accessor: "grade" },
      { Header: "Brand", accessor: "brandName" },
      { Header: "Avg Weight", accessor: "avgWeight" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Remarks", accessor: "remarks" },
      {
        Header: "Created By",
        accessor: "createdBy",
      },
      // {
      //   Header: "Created At",
      //   accessor: "createdAt",
      //   Cell: ({ value }) =>
      //     new Date(value).toLocaleDateString("en-GB", {
      //       day: "2-digit",
      //       month: "2-digit",
      //       year: "numeric",
      //     }),
      // },
      {
        Header: "Status",
        accessor: "status",
        // Cell: ({ value }) => {
        //   let badgeClass = "bg-secondary";
        //   if (value === "Suggested") badgeClass = "bg-warning";
        //   else if (value === "Approved") badgeClass = "bg-success";
        //   else if (value === "Rejected") badgeClass = "bg-danger";

        //   return (
        //     <span className={`badge ${badgeClass}`}>
        //       {value}
        //     </span>
        //   );
        // },
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="dropdown">
              <button
                className="btn btn-sm btn-outline-secondary"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon icon={faEllipsisV} />
              </button>
              <ul className="dropdown-menu">
                {row.original.status == 'Suggested'?
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleApproveSuggestion(row.original)}
                  >
                    <FontAwesomeIcon icon={faThumbsUp} className="me-2" />
                    Action
                  </button>
                </li>
                :null}
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleRejectSuggestion(row.original.id)}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} className="me-2" />
                    Reject
                  </button>
                </li>
                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => handleRejectSuggestion(row.original.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} className="me-2" />
                    Delete
                  </button>
                </li>
              </ul>
            </div>
          );
        },
      },
    ],
    []
  );
  const allItems = React.useMemo(
    () => [...items, ...approvedItems, ...rejectedItems],
    [items, approvedItems, rejectedItems]
  );
  const columnsAll = React.useMemo(
    () => [
      { Header: "Print Name", accessor: "printName" },
      // { Header: "Inventory", accessor: "itemName" },
      // { Header: "Size", accessor: "size" },
      // { Header: "Color", accessor: "color" },
      // { Header: "Made of (Material)", accessor: "make" },
      // { Header: "Grade", accessor: "grade" },
      // { Header: "Brand Name", accessor: "brandName" },
      { Header: "UOM", accessor: "uom" },
      { Header: "Weight", accessor: "avgWeight" },
      { Header: "Alias", accessor: "additionalNames" },
      { Header: "Depts", accessor: "concernedDepartments" },
      { Header: "Description", accessor: "itemDesc" },
      {
        Header: "Group",
        accessor: "itemGroupCode",
        Cell: ({ row }) => {
          const { itemGroupCode, itemGroup } = row.original;
          return `${itemGroupCode} - ${itemGroup}`;
        },
      },
      { Header: "Type", accessor: "type" },
      { Header: "Reason", accessor: "rejectedReason" }, // Will be empty for non-rejected items
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ row }) => {
          if (items.some((item) => item.id === row.original.id)) return "Draft";
          if (approvedItems.some((item) => item.id === row.original.id))
            return "Final";
          if (rejectedItems.some((item) => item.id === row.original.id))
            return "On Hold";
          return "Unknown";
        },
      },
      {
        Header: "Actions",
        Cell: ({ row }) => {
          const item = row.original;
          const isDraft = items.some((i) => i.id === item.id);
          const isApproved = approvedItems.some((i) => i.id === item.id);
          const isRejected = rejectedItems.some((i) => i.id === item.id);

          return (
            <div className="d-flex gap-2 align-items-center">
              {isDraft && (
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-outline-secondary "
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleApprove(row.original)}
                      >
                        <FontAwesomeIcon icon={faThumbsUp} className="me-2" />
                        Approve
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleEdit(row.original)}
                      >
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        Edit
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleDelete(row.original)}
                      >
                        <FontAwesomeIcon icon={faTrash} className="me-2" />
                        Delete
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleReject(row.original)}
                      >
                        <FontAwesomeIcon
                          icon={faTimesCircle}
                          className="me-2"
                        />
                        Reject
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item">
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                        {row.original.createdByFirstName}
                      </button>
                    </li>
                  </ul>
                </div>
              )}

              {isApproved && (
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-outline-secondary "
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleEdit(row.original)}
                      >
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        Edit
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleDelete(row.original)}
                      >
                        <FontAwesomeIcon icon={faTrash} className="me-2" />
                        Delete
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleReject(row.original)}
                      >
                        <FontAwesomeIcon
                          icon={faTimesCircle}
                          className="me-2"
                        />
                        Reject
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item">
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                        {row.original.createdByFirstName}
                      </button>
                    </li>
                  </ul>
                </div>
              )}

              {isRejected && (
                <div className="dropdown">
                  <button
                    className="btn btn-sm btn-outline-secondary "
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <FontAwesomeIcon icon={faEllipsisV} />
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleEdit(row.original)}
                      >
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        Edit
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleApprove(row.original)}
                      >
                        <FontAwesomeIcon icon={faThumbsUp} className="me-2" />
                        Approve
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => handleDelete(row.original)}
                      >
                        <FontAwesomeIcon icon={faTrash} className="me-2" />
                        Delete
                      </button>
                    </li>
                    <li>
                      <button className="dropdown-item">
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
                        {row.original.createdByFirstName}
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          );
        },
      },
    ],
    [items, approvedItems, rejectedItems]
  );
  const filteredAllItems = React.useMemo(() => {
    return allItems.filter((item) => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup =
        !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name &&
          item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [allItems, typeFilter, groupFilterCode, createdByFilter]);
  const tableInstanceAll = useTable(
    {
      columns: columnsAll,
      data: filteredAllItems,
      initialState: {
        pageIndex: parseInt(localStorage.getItem("currentAllPageIndex")) || 0,
        pageSize: parseInt(localStorage.getItem("currentAllPageSize")) || 25,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const filteredItems = React.useMemo(() => {
    return items.filter((item) => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup =
        !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name &&
          item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [items, typeFilter, groupFilterCode, createdByFilter]);

  const filteredApprovedItems = React.useMemo(() => {
    return approvedItems.filter((item) => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup =
        !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name &&
          item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [approvedItems, typeFilter, groupFilterCode, createdByFilter]);

  const filteredRejectedItems = React.useMemo(() => {
    return rejectedItems.filter((item) => {
      const matchesType = typeFilter === "All" || item.type === typeFilter;
      const matchesGroup =
        !groupFilterCode || item.itemGroupCode === groupFilterCode;
      const matchesCreator =
        !createdByFilter ||
        (item.createdByFirstName === createdByFilter.name &&
          item.badgeId === createdByFilter.badge);
      return matchesType && matchesGroup && matchesCreator;
    });
  }, [rejectedItems, typeFilter, groupFilterCode, createdByFilter]);

  const storedDraftPageIndex =
    parseInt(localStorage.getItem("currentDraftPageIndex")) || 0;
  const storedDraftPageSize =
    parseInt(localStorage.getItem("currentDraftPageSize")) || 25;

  const storedFinalPageIndex =
    parseInt(localStorage.getItem("currentFinalPageIndex")) || 0;
  const storedFinalPageSize =
    parseInt(localStorage.getItem("currentFinalPageSize")) || 25;

  const storedRejectedPageIndex =
    parseInt(localStorage.getItem("currentRejectedPageIndex")) || 0;
  const storedRejectedPageSize =
    parseInt(localStorage.getItem("currentRejectedPageSize")) || 25;

  const storedSuggestionPageIndex =
    parseInt(localStorage.getItem("currentSuggestionPageIndex")) || 0;
  const storedSuggestionPageSize =
    parseInt(localStorage.getItem("currentSuggestionPageSize")) || 25;

  const tableInstance1 = useTable(
    {
      columns,
      data: filteredItems,
      initialState: {
        pageIndex: storedDraftPageIndex,
        pageSize: storedDraftPageSize,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const tableInstance2 = useTable(
    {
      columns: columnsApproved,
      data: filteredApprovedItems,
      initialState: {
        pageIndex: storedFinalPageIndex,
        pageSize: storedFinalPageSize,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const tableInstance3 = useTable(
    {
      columns: columnsRejected,
      data: filteredRejectedItems,
      initialState: {
        pageIndex: storedRejectedPageIndex,
        pageSize: storedRejectedPageSize,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const tableInstance4 = useTable(
    {
      columns: columnSuggestion,
      data: suggestion,
      initialState: {
        pageIndex: storedSuggestionPageIndex,
        pageSize: storedSuggestionPageSize,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (tableInstance1?.state) {
      const { pageIndex, pageSize } = tableInstance1.state;
      localStorage.setItem("currentDraftPageIndex", pageIndex);
      localStorage.setItem("currentDraftPageSize", pageSize);
    }
  }, [tableInstance1?.state?.pageIndex, tableInstance1?.state?.pageSize]);

  useEffect(() => {
    if (tableInstance2?.state) {
      const { pageIndex, pageSize } = tableInstance2.state;
      localStorage.setItem("currentFinalPageIndex", pageIndex);
      localStorage.setItem("currentFinalPageSize", pageSize);
    }
  }, [tableInstance2?.state?.pageIndex, tableInstance2?.state?.pageSize]);

  useEffect(() => {
    if (tableInstance3?.state) {
      const { pageIndex, pageSize } = tableInstance3.state;
      localStorage.setItem("currentRejectedPageIndex", pageIndex);
      localStorage.setItem("currentRejectedPageSize", pageSize);
    }
  }, [tableInstance3?.state?.pageIndex, tableInstance3?.state?.pageSize]);

  useEffect(() => {
    if (tableInstance4?.state) {
      const { pageIndex, pageSize } = tableInstance3.state;
      localStorage.setItem("currentSuggestionPageIndex", pageIndex);
      localStorage.setItem("currentSuggestionPageSize", pageSize);
    }
  }, [tableInstance4?.state?.pageIndex, tableInstance4?.state?.pageSize]);
  useEffect(() => {
    if (tableInstanceAll?.state) {
      const { pageIndex, pageSize } = tableInstanceAll.state;
      localStorage.setItem("currentAllPageIndex", pageIndex);
      localStorage.setItem("currentAllPageSize", pageSize);
    }
  }, [tableInstanceAll?.state?.pageIndex, tableInstanceAll?.state?.pageSize]);
  // Helper for Rendering Tables
  const renderTable = ({
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex = 0, pageSize = 25, globalFilter },
    setGlobalFilter,
    pageOptions = [],
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    setPageSize,
    state,
    typeFilter,
    setTypeFilter,
  }) => {
    // Get the filtered rows count
    const filteredRowsCount = page.length;

    return (
      <div>
        <div className="row align-items-center mb-2">
          {/* Global Filter */}
          <div className="col-md-8">
            <GlobalFilter
              filter={state.globalFilter}
              setFilter={setGlobalFilter}
            />
          </div>
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              value={`Items: ${activeTab === "all"
                  ? items.length + approvedItems.length + rejectedItems.length
                  : activeTab === "draft"
                    ? items.length
                    : activeTab === "finalized"
                      ? approvedItems.length
                      : activeTab === "suggestion"
                        ? suggestion.length
                        : rejectedItems.length
                }`}
              style={{
                marginBottom: "10px",
                padding: "8px",
                fontSize: "16px",
                width: "100%",
                boxSizing: "border-box",
              }}
              disabled
            />
          </div>
          {activeTab != "suggestion" && (
            <>
              <div className="col-md-4">
                <Select
                  options={createdByOptions} // [{ value: "BADGE001", label: "John - BADGE001", name: "John" }]
                  value={
                    createdByOptions.find(
                      (opt) =>
                        opt.value === createdByFilter?.badge &&
                        opt.name === createdByFilter?.name
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    const selected = selectedOption
                      ? {
                        name: selectedOption.name,
                        badge: selectedOption.value,
                      }
                      : null;
                    setCreatedByFilter(selected);
                    localStorage.setItem(
                      "createdByFilter",
                      JSON.stringify(selected)
                    );
                    resetAllFilters();
                  }}
                  placeholder="Filter by Created By"
                  isClearable
                />
              </div>
              <div className="col-md-4">
                <Select
                  options={itemGroups}
                  value={
                    itemGroups.find(
                      (opt) => opt.itemGroupCode === groupFilterCode
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    const selectedCode = selectedOption?.itemGroupCode || "";
                    setGroupFilterCode(selectedCode);
                    localStorage.setItem("groupFilterCode", selectedCode);
                    resetAllFilters();
                  }}
                  placeholder="Select Item Group"
                  isClearable
                />
              </div>
              <div className="col-md-4">
                <select
                  className="form-select"
                  value={typeFilter}
                  onChange={(e) => {
                    const value = e.target.value;
                    setTypeFilter(value);
                    localStorage.setItem("typeFilter", value);
                    resetAllFilters();
                  }}
                  style={{
                    marginBottom: "10px",
                    padding: "8px",
                    fontSize: "16px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  <option value="All">All</option>
                  <option value="Asset">AC - Asset</option>
                  <option value="Consumables">CU - Consumables</option>
                  <option value="Fixtures & Fittings">
                    FF - Fixtures & Fittings
                  </option>
                </select>
              </div>
            </>
          )}
        </div>
        <div className="table-responsive">
          <table
            {...getTableProps()}
            className="table table-striped"
            style={{ fontSize: "13px", verticalAlign: "baseline" }}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.render("Header")}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <div>
            <button
              className="btn btn-secondary me-2"
              onClick={previousPage}
              disabled={!canPreviousPage}
            >
              Previous
            </button>
            <button
              className="btn btn-secondary"
              onClick={nextPage}
              disabled={!canNextPage}
            >
              Next
            </button>
          </div>
          <span>
            Page {pageIndex + 1} of {pageOptions.length}
          </span>
          <select
            className="form-select w-auto"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
          >
            {[25, 50, 75, 100].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
        </div>
      </div>
    );
  };

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Inventory Master</h3>
        <div className="ledger-count">
          Total Items:{" "}
          <strong>
            {items.length + approvedItems.length + rejectedItems.length}
          </strong>
        </div>
      </div>
      <></>
      <div className="formcontainer mt-2">
        <ul className="nav nav-tabs" id="itemTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "all" ? "active" : ""}`}
              id="all-tab"
              data-bs-toggle="tab"
              data-bs-target="#all"
              type="button"
              role="tab"
              aria-controls="all"
              aria-selected={activeTab === "all"}
              onClick={() => handleTabClick("all")}
            >
              All Items
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "suggestion" ? "active" : ""
                }`}
              id="suggestion-tab"
              data-bs-toggle="tab"
              data-bs-target="#suggestion"
              type="button"
              role="tab"
              aria-controls="suggestion"
              aria-selected={activeTab === "suggestion"}
              onClick={() => handleTabClick("suggestion")}
            >
              Suggestions
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "draft" ? "active" : ""}`}
              id="draft-tab"
              data-bs-toggle="tab"
              data-bs-target="#draft"
              type="button"
              role="tab"
              aria-controls="draft"
              aria-selected={activeTab === "draft"}
              onClick={() => handleTabClick("draft")}
            >
              Draft Items
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "finalized" ? "active" : ""
                }`}
              id="finalized-tab"
              data-bs-toggle="tab"
              data-bs-target="#finalized"
              type="button"
              role="tab"
              aria-controls="finalized"
              aria-selected={activeTab === "finalized"}
              onClick={() => handleTabClick("finalized")}
            >
              Finalized Items
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${activeTab === "rejected" ? "active" : ""}`}
              id="rejected-tab"
              data-bs-toggle="tab"
              data-bs-target="#rejected"
              type="button"
              role="tab"
              aria-controls="rejected"
              aria-selected={activeTab === "rejected"}
              onClick={() => handleTabClick("rejected")}
            >
              On Hold Items
            </button>
          </li>
        </ul>

        {/* Tab content */}
        <div className="tab-content mt-3" id="itemTabsContent">
          <div
            className={`tab-pane fade ${activeTab === "all" ? "show active" : ""
              }`}
            id="all"
            role="tabpanel"
            aria-labelledby="all-tab"
          >
            {renderTable({ ...tableInstanceAll, typeFilter, setTypeFilter })}
          </div>
          <div
            className={`tab-pane fade ${activeTab === "suggestion" ? "show active" : ""
              }`}
            id="suggestion"
            role="tabpanel"
            aria-labelledby="suggestion-tab"
          >
            {activeTab === "suggestion" &&
              renderTable({ ...tableInstance4, typeFilter, setTypeFilter })}
          </div>
          <div
            className={`tab-pane fade ${activeTab === "draft" ? "show active" : ""
              }`}
            id="draft"
            role="tabpanel"
            aria-labelledby="draft-tab"
          >
            {activeTab === "draft" &&
              renderTable({ ...tableInstance1, typeFilter, setTypeFilter })}
          </div>
          <div
            className={`tab-pane fade ${activeTab === "finalized" ? "show active" : ""
              }`}
            id="finalized"
            role="tabpanel"
            aria-labelledby="finalized-tab"
          >
            {activeTab === "finalized" &&
              renderTable({ ...tableInstance2, typeFilter, setTypeFilter })}
          </div>
          <div
            className={`tab-pane fade ${activeTab === "rejected" ? "show active" : ""
              }`}
            id="rejected"
            role="tabpanel"
            aria-labelledby="rejected-tab"
          >
            {activeTab === "rejected" &&
              renderTable({ ...tableInstance3, typeFilter, setTypeFilter })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemMasterApproval;
